import { Pill } from "@clipboard-health/ui-components";
import { TimeSlot } from "@src/appV2/redesign/Shift/Open/types";

import { TimeSlotPill } from "../../../Shift/TimeSlotPill";
import { ReviewTag } from "../api/useWorkplaceComments";

interface ReviewTagPillProps {
  content: ReviewTag | TimeSlot;
}

function isTimeSlot(value: ReviewTag | TimeSlot): value is TimeSlot {
  return Object.values(TimeSlot).some((timeSlot) => timeSlot === value);
}

export function ReviewTagPill(props: ReviewTagPillProps) {
  const { content } = props;

  // Old behavior show time slot pill AND the FLEX review tag
  if (isTimeSlot(content)) {
    return <TimeSlotPill timeSlot={content} size="small" variant="filled" />;
  }

  if (content === ReviewTag.STAFF) {
    return (
      <Pill
        size="small"
        variant="filled"
        label="Staff"
        iconType="user"
        color={(theme) => theme.palette.common.white}
        iconColor={(theme) => theme.palette.common.white}
        backgroundColor={(theme) => theme.palette.background.invert}
        sx={{ width: "fit-content" }}
      />
    );
  }

  return null;
}
